import { dateFormat } from '@/utils/formatter'
export default {
    name:'datetime',
    format: (v) => {
        return v ? dateFormat(v, 'yyyy-MM-dd hh:mm:ss') : ''
    }
}